import * as React from 'react';

import { useIntl } from 'react-intl';

import BKPayLog from 'components/icons/bk-pay-logo';
import { BluecodePlugin } from 'plugins';

import { BKPayLogoButton } from './styled';

export const BkPayButton = () => {
  const { formatMessage } = useIntl();
  const title = formatMessage({ id: 'bk_logo_title' });

  const handleButtonClick = async () => await BluecodePlugin.show();

  return (
    <BKPayLogoButton onClick={handleButtonClick}>
      <BKPayLog title={title} data-testid="bkpay-logo" />
    </BKPayLogoButton>
  );
};
